export const PayPalContainerId = '#paypal-container';
